<template>
    <Layout>
        <q-card class="flexbox">
            <div class="profile-header">
                <div class="profile-header-title">Classes</div>
                <div class="profile-header-icons">
                    <q-btn color="red" round @click="addModal">
                        <q-icon color="white" name="fas fa-plus" size="15px" class="cursor-pointer"></q-icon>
                    </q-btn>
                </div>
            </div>
            <div class="profile-content">
                <div style="width:100%">
                    <div class="row q-gutter-md q-pb-md">
                        <div class="col" v-if="selectedCompany">
                            <q-select v-model="selectedCompany"
                                      :options="companies"
                                      :option-label="company => company.name"
                                      :option-value="company => company"
                                      disable
                                      label="Company"/>
                        </div>
                        <div class="col" v-if="selectedCompany">
                            <q-select v-model="selectedGroup"
                                      :options="groups"
                                      :option-label="group => group.name"
                                      :option-value="group => group"
                                      label="Group"/>
                        </div>
                    </div>
                    <empty-value
                            description="If you want to add group please hit the button."
                            name="group"
                            v-if="items.length === 0 && !loading"
                    ></empty-value>
                    <loading v-if="items.length === 0 && loading"></loading>
                    <div v-if="items.length > 0 && !loading" class="row q-col-gutter-md">
                        <q-table
                                ref="table"
                                :data="items"
                                :columns="columns"
                                row-key="name"
                                :pagination="{page: 1, rowsPerPage: 0}"
                                hide-bottom
                                style="width: 100%"
                                class="no-shadow"
                        >
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td key="name" :props="props" style="width: 25%">
                                        {{ props.row.name }}
                                    </q-td>
                                    <q-td key="group" :props="props" style="width: 50%">
                                        {{ props.row.group.name }}
                                    </q-td>
                                    <q-td key="company" :props="props" style="width: 50%">
                                        {{ props.row.company.name }}
                                    </q-td>
                                    <q-td key="id" :props="props" style="width: 25%">
                                        <q-btn color="primary" round dense @click="editModal(props.row)"
                                               class="q-mr-xs">
                                            <q-tooltip>Edit</q-tooltip>
                                            <q-icon name="fas fa-edit" size="15px" class="cursor-pointer"></q-icon>
                                        </q-btn>
                                        <q-btn color="red" round dense @click="onDelete(props.row.id)">
                                            <q-tooltip>Delete</q-tooltip>
                                            <q-icon name="fas fa-trash" size="15px" class="cursor-pointer"></q-icon>
                                        </q-btn>
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </div>
                    <q-btn color="secondary"
                           label="Back to groups"
                           class="q-mt-md"
                           @click="$router.push({ name: 'groups', companyId: $route.params.companyId})"></q-btn>
                </div>
            </div>
        </q-card>
        <q-dialog v-model="deleteConfirm" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <span class="q-ml-sm">Are you sure delete this item?</span>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="Yes" color="red" @click="handleDelete"/>
                    <q-btn label="No" color="primary" v-close-popup/>
                </q-card-actions>
            </q-card>
        </q-dialog>
        <class-form-modal :type="modalType"
                          :open.sync="isAddModalOpen"
                          :data-selected-company.sync="selectedCompany"
                          :data-groups.sync="groups"
                          :data-selected-group.sync="selectedGroup"
                          :data-id="id"
                          :data-name="name"
                          :callback="handleUpdate"></class-form-modal>
    </Layout>
</template>

<script>
import axios from "../axios/index";
import Loading from "@/components/Loading.vue";
import EmptyValue from "@/components/EmptyValue.vue";
import Layout from "@/components/Layout.vue";
import ClassFormModal from "@/components/ClassFormModal.vue";

export default {
    metaInfo() {
        return {
            title: "Managing the Classes | FMS",
            meta: [
                {
                    name: "description",
                    content: ''
                },
                {
                    property: "og:title",
                    content: "Managing the Classes | FMS",
                },
                {property: "og:site_name", content: "FMS"},
                {property: "og:type", content: "website"},
                {name: "robots", content: "index,follow"},
            ],
        };
    },
    components: {ClassFormModal, Layout, EmptyValue, Loading},
    data() {
        return {
            loading: false,
            companies: [],
            selectedCompany: null,
            groups: [],
            selectedGroup: null,
            items: [],
            columns: [
                {name: 'name', label: 'Name', field: 'name', sortable: true},
                {name: 'group', label: 'Group', field: 'group', sortable: true},
                {name: 'company', label: 'Company', field: 'company', sortable: true},
                {name: 'id', label: 'Actions', field: 'id'}
            ],
            isAddModalOpen: false,
            modalType: 'add',
            id: null,
            name: null,
            deleteConfirm: false,
            deleteId: null,
        }
    },
    async mounted() {
        await this.getCompanies();
        await this.getGroups();
    },
    methods: {
        async getCompanies() {
            this.loading = true;
            try {
                const response = await axios.get("/companies");
                this.companies = response.data.data;
                this.selectedCompany = this.$route.params.companyId;
                this.selectedGroup = this.$route.params.groupId;
                this.companies.find(company => {
                    if (company.id === this.selectedCompany) {
                        this.selectedCompany = company;
                    }
                });
                this.groups.find(group => {
                    if (group.id === this.selectedGroup) {
                        this.selectedGroup = group;
                    }
                });
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        async getGroups() {
            this.loading = true;
            try {
                const response = await axios.get('/company-vehicle-groups', {
                    params: {
                        company_id: this.selectedCompany.id
                    }
                });
                this.groups = response.data.data;
                this.selectedGroup = this.$route.params.groupId;
                this.groups.find(group => {
                    if (group.id === this.selectedGroup) {
                        this.selectedGroup = group;
                    }
                });
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        async getCompanyVehicleClasses(companyId, groupId) {
            if (!groupId) {
                return;
            }

            this.loading = true;
            this.items = [];
            try {
                const response = await axios.get('/company-vehicle-classes', {
                    params: {
                        company_id: companyId,
                        group_id: groupId
                    }
                });
                const items = response.data.data;
                if (items.length > 0) {
                    for (const key in items) {
                        this.items.push({
                            id: items[key].id,
                            group: items[key].group,
                            company: items[key].company,
                            name: items[key].name
                        })
                    }
                } else {
                    this.items = [];
                }
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.log(e);
            }
        },
        addModal() {
            this.modalType = 'add';
            this.id = null;
            this.name = '';
            this.isAddModalOpen = true;
        },
        editModal(item) {
            this.modalType = 'edit';
            this.id = item.id;
            this.name = item.name;
            this.isAddModalOpen = true;
        },
        onDelete(id) {
            this.deleteConfirm = true;
            this.deleteId = id;
        },
        async handleDelete() {
            try {
                const response = await axios.delete(`/company-vehicle-class/${this.deleteId}`);
                if (response.status === 200) {
                    this.items = this.items.filter(item => item.id !== this.deleteId);
                }
                this.$q.notify({
                    message: response.data.message,
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'positive'
                });
            } catch (e) {
                this.$q.notify({
                    message: 'Something went wrong. Please try again.',
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'positive'
                });
            } finally {
                this.deleteConfirm = false;
            }
        },
        handleUpdate() {
            this.getCompanyVehicleClasses(this.selectedCompany.id, this.selectedGroup.id);
        }
    },
    watch: {
        selectedGroup: function (val) {
            if (val) {
                this.getCompanyVehicleClasses(this.selectedCompany.id, val.id);
            }
        },
    }
};
</script>
